import { Shield, Lock, CheckCircle2, Eye, Server } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const SecuritySection = () => {
  const { t } = useLanguage();

  return (
    <section id="security" className="section-padding bg-slate-50 border-t border-slate-200" style={{ scrollMarginTop: '80px' }} data-testid="security-section">
      <div className="container-max px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-4">
            <Shield className="w-6 h-6 text-[#0077FF]" />
            <span className="text-xs font-bold text-[#0077FF] uppercase tracking-widest">{t('security.label')}</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 leading-tight" data-testid="security-title">
            {t('security.title')}
          </h2>
        </div>

        <div className="space-y-16">
          {/* Designed to Minimize Risk */}
          <div className="grid lg:grid-cols-[40px_1fr] gap-4">
            <Shield className="w-6 h-6 text-[#0077FF] mt-1 hidden lg:block" />
            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-4">{t('security.designedTitle')}</h3>
              <p className="text-base text-slate-600 leading-relaxed mb-4">{t('security.designedBody1')}</p>
              <p className="text-sm text-slate-500 leading-relaxed">{t('security.designedBody2')}</p>
            </div>
          </div>

          {/* What We Do Not Store */}
          <div className="grid lg:grid-cols-[40px_1fr] gap-4">
            <Lock className="w-6 h-6 text-[#0077FF] mt-1 hidden lg:block" />
            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-4">{t('security.notStoreTitle')}</h3>
              <p className="text-base text-slate-600 leading-relaxed mb-6">{t('security.notStoreBody')}</p>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {(t('security.notStoreItems') || []).map((item, i) => (
                  <div key={i} className="flex items-center gap-2.5 bg-white rounded-lg px-4 py-3 border border-[#0077FF]/15">
                    <CheckCircle2 className="w-4 h-4 text-red-500 flex-shrink-0" />
                    <span className="text-sm text-slate-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Security Controls */}
          <div className="grid lg:grid-cols-[40px_1fr] gap-4">
            <Lock className="w-6 h-6 text-[#0077FF] mt-1 hidden lg:block" />
            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-4">{t('security.controlsTitle')}</h3>
              <div className="space-y-4">
                <p className="text-base text-slate-600 leading-relaxed">{t('security.controlsBody1')}</p>
                <p className="text-base text-slate-600 leading-relaxed">{t('security.controlsBody2')}</p>
                <p className="text-sm text-slate-500 leading-relaxed">{t('security.controlsBody3')}</p>
              </div>
            </div>
          </div>

          {/* Accountability */}
          <div className="grid lg:grid-cols-[40px_1fr] gap-4">
            <Eye className="w-6 h-6 text-[#0077FF] mt-1 hidden lg:block" />
            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-4">{t('security.accountabilityTitle')}</h3>
              <p className="text-base text-slate-600 leading-relaxed">{t('security.accountabilityBody')}</p>
            </div>
          </div>

          {/* Infrastructure Protection */}
          <div className="grid lg:grid-cols-[40px_1fr] gap-4">
            <Server className="w-6 h-6 text-[#0077FF] mt-1 hidden lg:block" />
            <div>
              <h3 className="text-lg font-bold text-slate-900 mb-4">{t('security.infrastructureTitle')}</h3>
              <p className="text-base text-slate-600 leading-relaxed">{t('security.infrastructureBody')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecuritySection;
